import './App.css'

import React from 'react'
import {Route, Routes} from 'react-router-dom'
import {useNavigate} from 'react-router'
import {PrivacyPage, SupportPage} from './test/testWidget'

// const GoogleMapScripts = () => {
//   return <script
//     src={`https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}&libraries=places`}
//   ></script>
// }

function loadGoogleMaps (apiKey: string): Promise<void> {
  return new Promise((resolve, reject) => {
    if (window.google && window.google.maps) {
      resolve() // Already loaded
      return
    }

    const script = document.createElement('script')
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`
    script.async = true
    script.defer = true
    script.onload = () => resolve()
    script.onerror = () => reject(new Error('Google Maps API failed to load'))

    document.head.appendChild(script)
  })
}

export default function App () {
  // useEffect(() => {
  //   loadGoogleMaps(googleMapsApiKey)
  //     .catch((err) => console.error('Error loading google maps dependency', err))
  // }, [])


  const [confirmationBoxContinueAction, setConfirmationBoxContinueAction] =
    React.useState(() => (input: any) => {
    })

  return (
    <div className={`font-sans text-standard-node-text`}>
      <Routes>
        {/*<Route*/}
        {/*  path="/graph"*/}
        {/*  exact*/}
        {/*  element={*/}
        {/*    <ProtectedPage*/}
        {/*      path={'/graph'}*/}
        {/*      widget={*/}
        {/*        <GraphPage*/}
        {/*          confirmationBoxContinueAction={confirmationBoxContinueAction}*/}
        {/*          setConfirmationBoxContinueAction={*/}
        {/*            setConfirmationBoxContinueAction*/}
        {/*          }*/}
        {/*        />*/}
        {/*      } />*/}
        {/*  }*/}
        {/*/>*/}
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/bottled/privacy" element={<PrivacyPage />} />
        <Route path="/bottled/support" element={<SupportPage />} />
        <Route path="/health" element={<Health />} />
        <Route path="/" element={<SupportPage />} />
        {/*<Route*/}
        {/*  path="/"*/}
        {/*  element={*/}
        {/*    <ProtectedPage*/}
        {/*      widget={*/}
        {/*        <HomePage*/}
        {/*          confirmationBoxContinueAction={confirmationBoxContinueAction}*/}
        {/*          setConfirmationBoxContinueAction={*/}
        {/*            setConfirmationBoxContinueAction*/}
        {/*          }*/}
        {/*        />*/}
        {/*      }*/}
        {/*      path={'/'}*/}
        {/*    ></ProtectedPage>*/}
        {/*  }*/}
        {/*/>*/}
        {/*<Route path="/signup" element={<LoginPage />} />*/}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </div>
  )
}

function getRandomInt (max: number) {
  return Math.floor(Math.random() * max)
}

const pageNotFoundMessages = ['Page not found.', 'We couldn\'t find your page.', 'Page not found. That\'s awkward.']

export function NotFoundPage (props: {}) {
  const navigate = useNavigate()
  return <div className="text-center justify-center flex items-center h-screen space-y-16 flex-col">
    <div className="">
      <div className="text-4xl font-extrabold">404</div>
      <br></br>
      {pageNotFoundMessages[getRandomInt(pageNotFoundMessages.length)]}
    </div>

    <button className="bg-accent-3 font-semibold rounded-full w-fit h-full text-white py-1.5 px-5" onClick={() => {
      navigate('/')
    }}>
      Home Page
    </button>
  </div>
}

export function Health (props: {}) {
  return <div>
    Healthy
  </div>
}

//
// export function TeamSearchTab (props: { teams: any[] }) {
//   return (
//     <div className="flex flex-col">
//       <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
//         <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
//           <div className="border-gray-200 overflow-hidden border sm:rounded-lg">
//             <table className="min-w-full divide-y divide-gray-200">
//               <thead className="bg-gray-50">
//               <tr>
//                 <th
//                   scope="col"
//                   className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
//                 >
//                   Team
//                 </th>
//                 <th
//                   scope="col"
//                   className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
//                 >
//                   Member Count
//                 </th>
//                 <th
//                   scope="col"
//                   className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
//                 >
//                   Created
//                 </th>
//               </tr>
//               </thead>
//               <tbody className="bg-white divide-y divide-gray-200">
//               {
//                 props.teams.map((team: any) => {
//                   const date = new Date(team.created)
//                   const formattedDate = date.toLocaleDateString('en-UK', {
//                     year: 'numeric',
//                     month: 'long',
//                     day: 'numeric'
//                   })
//
//                   return (
//                     <tr key={`${team.name}`}>
//                       <td className="px-6 py-4 whitespace-nowrap text-gray-700">
//                         {team.name}
//                         {/* Content for Row 1, Column 1 */}
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-gray-700">
//                         {team.memberCount}
//                         {/* Content for Row 1, Column 2 */}
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-gray-700">
//                         {formattedDate}
//                         {/* Content for Row 1, Column 3 */}
//                       </td>
//                     </tr>)
//                 })
//               }
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }
//
// interface UserAccessLevel {
//   id: string,
//   name: string,
//   email: string,
//   picture: string,
//   accessLevel: AccessLevel,
// }
//
//
// export function ShareWorkspaceBox (props: { graphData: any | null }) {
//
//   const [isHidden, setIsHidden] = useReduxPair((state: RootState) => state.shareWorkspaceBoxIsHidden, setShareWorkspaceBoxIsHiddenAction)
//   const [link, setLink] = useState<null | string>(null)
//   const [copied, setCopied] = useState(false)
//   const currentWorkspace = useReduxState((state) => state.currentWorkspace)
//
//   const inputRef = useRef<HTMLInputElement | null>(null)
//
//   useEffect(() => {
//     if (!props.graphData || isHidden) {
//       return
//     }
//     setLink(`${frontendUrl}/graph`)
//   }, [props.graphData, isHidden])
//
//   const [usersWithAccess, setUsersWithAccess] = useState<UserAccessLevel[]>(Array.of())
//
//   useEffect(() => {
//     if (currentWorkspace === null || isHidden) {
//       return
//     }
//     axiosInstance.get(absoluteEndpoint('/workspace/get-access-levels'), { params: { workspaceId: currentWorkspace } }).then((response) => {
//       setUsersWithAccess(response.data)
//     })
//   }, [currentWorkspace, isHidden])
//
//   const shareWorkspaceWithEmail = useCallback((email: string, workspace: string, accessLevel: string) => {
//     axiosInstance.post('/workspace/invite-user', {
//       invitedEmail: email,
//       workspaceId: currentWorkspace,
//       accessLevel: accessLevel
//     })
//   }, [currentWorkspace])
//
//   const [currentAccessLevel, setCurrentAccessLevel] = useState('can view')
//
//   return (<div className={isHidden ? 'hidden' : ''}>
//     <div
//       className="p-4 fixed flex items-center justify-center z-50 overflow-x-hidden overflow-y-auto md:inset-0 max-h-full bg-gray-300 bg-opacity-50 "
//     >
//       <div className="relative w-[36rem] h-96">
//         <div className="inline-block relative w-full bg-white rounded-2xl shadow dark:bg-gray-700 h-full">
//           <div className="px-8 pt-8">
//             <div className="flex justify-between items-center content-center pb-4">
//               <div className="text-2xl font-semibold text-gray-700">
//                 Share
//               </div>
//               <button
//                 onClick={() => {
//                   setIsHidden(true)
//                 }}
//               >
//                 <div className="rounded-full bg-gray-50 p-2">
//                   <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 -960 960 960" width="16">
//                     <path
//                       d="M480-405.912 293.044-218.956Q278.087-203.999 256-203.999q-22.087 0-37.044-14.957-14.957-14.957-14.957-37.044 0-22.087 14.957-37.044L405.912-480 218.956-666.956Q203.999-681.913 203.999-704q0-22.087 14.957-37.044 14.957-14.957 37.044-14.957 22.087 0 37.044 14.957L480-554.088l186.956-186.956q14.957-14.957 37.044-14.957 22.087 0 37.044 14.957 14.957 14.957 14.957 37.044 0 22.087-14.957 37.044L554.088-480l186.956 186.956q14.957 14.957 14.957 37.044 0 22.087-14.957 37.044-14.957 14.957-37.044 14.957-22.087 0-37.044-14.957L480-405.912Z" />
//                   </svg>
//                 </div>
//               </button>
//             </div>
//             {/*<div className="rounded-lg bg-gray-50 h-8 flex items-center justify-between space-x-2 px-5">*/}
//             {/*</div>*/}
//             <div className="flex">
//               <input
//                 type="text"
//                 ref={inputRef}
//                 className="bg-gray-100 h-8 rounded-l-lg font-medium w-full pb-1 pt-1 px-2 focus:outline-none placeholder:text-xs placeholder:text-gray-500 text-xs text-gray-700"
//                 placeholder="Enter teams or email addresses"
//               />
//               <div className="w-24 h-8 bg-gray-100 rounded-r-lg justify-center items-center place-items-center">
//                 <AccessButtonForSharing accessLevel={'can view'} currentAccessLevel={currentAccessLevel}
//                                         setCurrentAccessLevel={setCurrentAccessLevel}></AccessButtonForSharing>
//               </div>
//               <button
//                 onClick={() => {
//                   if (inputRef.current && currentWorkspace != null) {
//                     shareWorkspaceWithEmail(inputRef.current?.value, currentWorkspace, currentAccessLevel)
//                     // todo make this work and scroll bar for invited users
//                     // todo allow adding / making new workspaces
//                     // then deploy
//                     inputRef.current.value = ''
//
//                   }
//                   // todo: add user to allow list for workspace
//                 }}
//                 className="w-24 h-8 bg-blue-500 ml-2 px-2 pb-0.5 text-gray-50 rounded-lg text-center font-semibold text-sm">
//                 Share
//               </button>
//             </div>
//
//             <div className="pt-6 text-xs font-medium text-gray-500 pb-2">
//               People with access
//             </div>
//             <div>
//               {
//                 usersWithAccess.map((user) => {
//                   return <SharedMemberTile key={user.id} user={user}></SharedMemberTile>
//                 })
//               }
//             </div>
//             {/*<div className="pt-6 text-xs font-medium text-gray-600">*/}
//             {/*  Teams with access*/}
//             {/*</div>*/}
//
//             <div className="flex items-center pt-8 justify-between w-full">
//               {/*<div className="flex justify-between items-center content-center pt-8">*/}
//               <div className="flex items-center">
//                 {Icons.global}
//                 <div className="text-xs text-gray-500 pl-2 font-medium">
//                   Anyone with the link&nbsp;
//                 </div>
//                 <div className="flex items-center">
//                   <div className="text-xs font-semibold text-gray-700">
//                     can view
//                   </div>
//                   <div className="pt-0.5">
//                     {Icons.arrowDown}
//                   </div>
//                 </div>
//               </div>
//               <button
//                 className="rounded-lg border border-gray-200 text-xs font-medium text-gray-700 px-3 py-2 mr-0"
//                 onClick={async () => {
//                   if (link !== null) {
//                     navigator.clipboard.writeText(link).then(() => {
//                       setCopied(true)
//                       setTimeout(() => {
//                         setCopied(false)
//                       }, 500)
//                     })
//                   }
//                 }}
//               >
//                 Copy Link
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>)
// }
//
//
// export type AccessLevel = 'full access' | 'can edit' | 'can view'
//
// export function SharedMemberTile (props: {
//   user: UserAccessLevel,
// }) {
//   return <div id={props.user.id} className="w-full flex justify-between items-center py-1">
//     <div className="flex items-center space-x-2">
//       <div className="h-6 w-6 rounded-full bg-blue-400"></div>
//       <div className="text-sm text-gray-700 font-medium">
//         {props.user.name}
//       </div>
//     </div>
//     <AccessButtonForUsers accessLevel={props.user.accessLevel}></AccessButtonForUsers>
//   </div>
// }
//
// export function AccessButtonForUsers (props: { accessLevel: AccessLevel }) {
//   const containerRef = useRef<any>(null)
//   const [isSelected, setIsSelected] = useState(false)
//   const [mouseCoordinates, setMouseCoordinates] = useState({ top: 0, left: 0 })
//   const [memberAccessMenuIsVisible, setMemberAccessMenuIsVisible] = useState(false)
//   const [currentAccessLevel, setCurrentAccessLevel] = useState(props.accessLevel)
//
//   const handleClickOutside = useCallback((event: MouseEvent) => {
//     if (containerRef.current) {
//       const targetElement = event.target as HTMLElement
//
//       // const myButton = document.getElementById('myButton');
//       const { left, bottom } = targetElement.getBoundingClientRect()
//       if (containerRef.current.contains(event.target)) {
//         setIsSelected(true)
//         setMouseCoordinates({ top: bottom + 8, left: left })
//         setMemberAccessMenuIsVisible(true)
//       } else {
//         setIsSelected(false)
//         setMouseCoordinates({ top: bottom + 8, left: left })
//         setMemberAccessMenuIsVisible(false)
//       }
//     }
//   }, [])
//
//   useEffect(() => {
//     // Add event listener when the component mounts
//     document.addEventListener('click', handleClickOutside)
//
//     // Remove event listener when the component unmounts
//     return () => {
//       document.removeEventListener('click', handleClickOutside)
//     }
//   }, [handleClickOutside])
//
//
//   return <div>
//     <div className={`fixed h-40 w-44 bg-gray-800 p-2 rounded-2xl ${memberAccessMenuIsVisible ? 'visible' : 'hidden'}`}
//          style={{
//            left: mouseCoordinates.left,
//            top: mouseCoordinates.top
//          }}>
//       <AccessShareMenuTile isSelected={currentAccessLevel === 'full access'} primaryText={'Full access'}
//                            secondaryText={'Can edit and share'} setNewAccessLevel={() => {
//         setCurrentAccessLevel('full access')
//       }}
//       ></AccessShareMenuTile>
//       <AccessShareMenuTile isSelected={currentAccessLevel === 'can edit'} primaryText={'Can edit'}
//                            secondaryText={'Can edit but not share'} setNewAccessLevel={() => {
//         setCurrentAccessLevel('can edit')
//       }}></AccessShareMenuTile>
//       <AccessShareMenuTile isSelected={currentAccessLevel === 'can view'} primaryText={'Can view'}
//                            secondaryText={'Cannot edit or share'} setNewAccessLevel={() => {
//         setCurrentAccessLevel('can view')
//       }}></AccessShareMenuTile>
//     </div>
//
//     <button ref={containerRef}
//             className={`flex items-center pr-1 py-1 pl-2 rounded-lg border ${isSelected ? 'border-blue-500' : 'border-transparent'}`}
//             onClick={() => {
//             }}
//     >
//       <div
//         className={`pointer-events-none w-16 text-xs font-semibold ${isSelected ? 'text-gray-800' : 'text-gray-500'}`}>
//         {currentAccessLevel}
//       </div>
//       <div className="pointer-events-none pt-0.5">
//         {Icons.lightArrowDown}
//       </div>
//     </button>
//   </div>
// }
//
//
// export function AccessButtonForSharing (props: {
//   accessLevel: AccessLevel,
//   currentAccessLevel: string,
//   setCurrentAccessLevel: Dispatch<any>
// }) {
//   const containerRef = useRef<any>(null)
//   const [isSelected, setIsSelected] = useState(false)
//   const [mouseCoordinates, setMouseCoordinates] = useState({ top: 0, left: 0 })
//   const [memberAccessMenuIsVisible, setMemberAccessMenuIsVisible] = useState(false)
//
//   const handleClickOutside = useCallback((event: MouseEvent) => {
//     if (containerRef.current) {
//       const targetElement = event.target as HTMLElement
//
//       // const myButton = document.getElementById('myButton');
//       const { left, bottom } = targetElement.getBoundingClientRect()
//       if (containerRef.current.contains(event.target)) {
//         setIsSelected(true)
//         setMouseCoordinates({ top: bottom + 8, left: left })
//         setMemberAccessMenuIsVisible(true)
//       } else {
//         setIsSelected(false)
//         setMouseCoordinates({ top: bottom + 8, left: left })
//         setMemberAccessMenuIsVisible(false)
//       }
//     }
//   }, [])
//
//   useEffect(() => {
//     // Add event listener when the component mounts
//     document.addEventListener('click', handleClickOutside)
//
//     // Remove event listener when the component unmounts
//     return () => {
//       document.removeEventListener('click', handleClickOutside)
//     }
//   }, [handleClickOutside])
//
//
//   return <div>
//     <div className={`fixed h-40 w-44 bg-gray-800 p-2 rounded-2xl ${memberAccessMenuIsVisible ? 'visible' : 'hidden'}`}
//          style={{
//            left: mouseCoordinates.left,
//            top: mouseCoordinates.top
//          }}>
//       <AccessShareMenuTile isSelected={props.currentAccessLevel === 'full access'} primaryText={'Full access'}
//                            secondaryText={'Can edit and share'} setNewAccessLevel={() => {
//         props.setCurrentAccessLevel('full access')
//       }}
//       ></AccessShareMenuTile>
//       <AccessShareMenuTile isSelected={props.currentAccessLevel === 'can edit'} primaryText={'Can edit'}
//                            secondaryText={'Can edit but not share'} setNewAccessLevel={() => {
//         props.setCurrentAccessLevel('can edit')
//       }}></AccessShareMenuTile>
//       <AccessShareMenuTile isSelected={props.currentAccessLevel === 'can view'} primaryText={'Can view'}
//                            secondaryText={'Cannot edit or share'} setNewAccessLevel={() => {
//         props.setCurrentAccessLevel('can view')
//       }}></AccessShareMenuTile>
//     </div>
//
//     <button ref={containerRef}
//             className={`flex items-center pt-1.5 rounded-lg`}
//             onClick={() => {
//             }}
//     >
//       <div
//         className={`pointer-events-none w-16 text-xs font-semibold ${isSelected ? 'text-gray-800' : 'text-gray-500'}`}>
//         {props.currentAccessLevel}
//       </div>
//       <div className="pointer-events-none pt-0.5 pr-1">
//         {Icons.lightArrowDown}
//       </div>
//     </button>
//   </div>
// }
//
//
// export function AccessShareMenuTile (props: {
//   isSelected: boolean,
//   primaryText: string,
//   secondaryText: string,
//   setNewAccessLevel: () => void
// }) {
//   return <button
//     className={`${props.isSelected ? 'bg-gray-600' : ''} w-full text-left rounded-lg p-2 text-xs`}
//     onClick={() => {
//       props.setNewAccessLevel()
//     }}>
//     <div className="font-medium text-gray-50">{props.primaryText}</div>
//     <div className="font-normal text-gray-300">{props.secondaryText}</div>
//   </button>
// }
//
// export function LinkUploadBox (props: { createUrl: (displayText: string, url: string) => void }) {
//   const linkRef = React.useRef<HTMLInputElement>(null)
//   const displayRef = React.useRef<HTMLInputElement>(null)
//   const { displayText, url, isHidden } = useReduxState((state: RootState) => state.urlCreationState)
//   const setIsHidden = useReduxAction(setUrlCreationStateAction)
//
//   useEffect(() => {
//     if (displayRef.current) {
//       displayRef.current.value = displayText ?? ''
//     }
//
//     if (linkRef.current) {
//       linkRef.current.value = url ?? ''
//     }
//   }, [displayText, url])
//
//   return (
//     <div className={isHidden ? 'hidden' : ''}>
//       <div
//         id="popup-modal"
//         tabIndex={-1}
//         className="p-4 fixed flex items-center justify-center z-50 overflow-x-hidden overflow-y-auto md:inset-0 max-h-full bg-gray-300 bg-opacity-50 "
//       >
//         <div className="relative w-full max-w-md max-h-full">
//           <div className="inline-block relative w-[28rem] bg-white rounded-lg shadow dark:bg-gray-700 p-6">
//             <div className="flex justify-between items-center content-center pb-8">
//               <div className="text-2xl font-semibold text-gray-700">
//                 Add Link
//               </div>
//               <button
//                 onClick={() => {
//                   setIsHidden({
//                     displayText: null,
//                     url: null,
//                     isHidden: true
//                   })
//                 }}
//               >
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   height="24"
//                   viewBox="0 -960 960 960"
//                   width="24"
//                   fill={gray[700]}
//                 >
//                   <path
//                     d="m249-207-42-42 231-231-231-231 42-42 231 231 231-231 42 42-231 231 231 231-42 42-231-231-231 231Z"
//                     className="fill-gray-500"
//                   />
//                 </svg>
//               </button>
//             </div>
//
//             <div className="text-sm pb-2 font-semibold text-gray-700">
//               Link
//             </div>
//             <div
//               className="w-full h-11 mb-4 rounded-lg text-xs focus:outline-none focus:ring-2 focus:ring-blue-500 focus:bg-white flex content-center justify-between items-center">
//               <input
//                 type="text"
//                 className="bg-white border border-gray-200 rounded-lg w-full py-3 px-4 focus:outline-none"
//                 placeholder="Insert your link"
//                 ref={linkRef}
//               />
//             </div>
//
//             <div className="text-sm pb-2 font-semibold text-gray-700">
//               Text (Optional)
//             </div>
//             <div
//               className="w-full h-11 mb-4 rounded-lg text-xs focus:outline-none focus:ring-2 focus:ring-blue-500 focus:bg-white flex content-center justify-between items-center">
//               <input
//                 type="text"
//                 className="rounded-lg w-full py-3 px-4 border border-gray-200 focus:outline-none"
//                 placeholder="Insert your display text"
//                 ref={displayRef}
//               />
//             </div>
//
//
//             <button
//               className="w-full bg-white shadow-sm font-semibold text-gray-700 border-gray-200 border rounded-lg h-12 mt-8 hover:bg-gray-50"
//               onClick={() => {
//
//                 let linkValue = linkRef.current?.value || ''
//
//                 let displayValue = displayRef.current?.value || ''
//                 if (displayValue === '') {
//                   displayValue = linkValue
//                 }
//
//                 if (linkValue.startsWith('http://')) {
//                   linkValue = linkValue.replace('http://', 'https://')
//                 } else if (!linkValue.startsWith('https://')) {
//                   linkValue = `https://${linkValue}`
//                 }
//
//                 props.createUrl(displayValue, linkValue || '')
//                 setIsHidden({
//                   displayText: null,
//                   url: null,
//                   isHidden: true
//                 })
//               }}
//             >
//               <div>
//                 Create Link
//               </div>
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }
//
// const ResizableInput: React.FC = () => {
//   const inputRef = useRef<HTMLDivElement | null>(null)
//   const [isPlaceholderVisible, setIsPlaceholderVisible] = useState(true)
//
//   const handleInput = () => {
//     if (inputRef.current) {
//       inputRef.current.style.height = 'auto'
//       inputRef.current.style.height = `${inputRef.current.scrollHeight}px`
//       setIsPlaceholderVisible(!inputRef.current.textContent)
//     }
//   }
//
//   return (
//
//     // <textarea name="Text1" cols="40" rows="5"></textarea>
//     <div
//       ref={inputRef}
//       contentEditable
//       onInput={handleInput}
//       data-placeholder="e.g. Added a new section on the importance of..."
//       className={`resize-y border rounded-md p-2 focus:outline-none ${isPlaceholderVisible ? 'placeholder-text-gray-500' : ''}`}
//       role="textbox"
//       aria-multiline="true"
//     />
//   )
// }
//
// // export function TopicVersionBox(props: {}) {
// //   const majorUpdateRef = React.useRef<HTMLInputElement>(null)
// //   const minorUpdateRef = React.useRef<HTMLInputElement>(null)
// //   const changeDescriptionRef = React.useRef<HTMLTextAreaElement>(null)
// //   // const [isHidden, setIsHidden] = React.useState(false)
// //   // const isHidden = true
// //   //
// //
// //   const setTopicVersionState = useReduxAction(setTopicVersionStateAction)
// //   const topicVersionState = useReduxState((state: RootState) => state.topicVersionState)
// //   const setIsHidden = (isHidden: boolean) => setTopicVersionState({ ...topicVersionState, isHidden: isHidden })
// //
// //   // setTopicVersionStateAction()
// //   // {
// //   //   isHidden: true,
// //   //     version: null,
// //   //     objectId: null
// //   // },
// //
// //   // state management for the link upload box
// //
// //   // currently selected text before triggering link box
// //   //
// //
// //   // inputRef.
// //
// //   // const [submitIsEnabled, setSubmitIsEnabled] = useState(false)
// //
// //   // useEffect(() => {
// //   // }, [majorUpdateRef, changeDescriptionRef])
// //   const [displayError, setDisplayError] = useState(false)
// //   const objectId = useReduxState((state: RootState) => state.objectId)
// //
// //   return (
// //     <div className={topicVersionState.isHidden ? "hidden" : ""}>
// //       <div
// //         id="popup-modal"
// //         tabIndex={-1}
// //         className="p-4 fixed flex items-center justify-center z-50 overflow-x-hidden overflow-y-auto md:inset-0 max-h-full bg-gray-300 bg-opacity-50 "
// //       >
// //         <div className="relative w-full max-w-md max-h-full">
// //           <div className="inline-block relative w-[28rem] bg-white rounded-lg shadow dark:bg-gray-700 p-6">
// //             <div className="flex justify-between items-center content-center pb-8">
// //               <div className="text-3xl font-bold text-gray-700">
// //                 Update Version
// //               </div>
// //               <button
// //                 onClick={() => {
// //                   setIsHidden(true)
// //                 }}
// //               >
// //                 <svg
// //                   xmlns="http://www.w3.org/2000/svg"
// //                   height="24"
// //                   viewBox="0 -960 960 960"
// //                   width="24"
// //                   fill={gray[700]}
// //                 >
// //                   <path
// //                     d="m249-207-42-42 231-231-231-231 42-42 231 231 231-231 42 42-231 231 231 231-42 42-231-231-231 231Z"
// //                     className="fill-gray-500"
// //                   />
// //                 </svg>
// //               </button>
// //             </div>
// //
// //
// //             <div className="text-base pb-2 font-semibold text-gray-700 pt-12 pt-4">
// //               What type of update is this?
// //             </div>
// //
// //             <ul
// //               className="items-center w-full text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg sm:flex dark:bg-gray-700 dark:border-gray-600 dark:text-white">
// //               <li className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r dark:border-gray-600">
// //                 <div className="flex items-center pl-6">
// //                   <input id="horizontal-list-radio-license" type="radio" value="" name="list-radio"
// //                          ref={majorUpdateRef}
// //                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-0 dark:bg-gray-600 dark:border-gray-500" />
// //                   <label htmlFor="horizontal-list-radio-license"
// //                          className="w-full py-3 ml-2 text-sm font-normal text-gray-700 dark:text-gray-300">Major
// //                     Update</label>
// //                 </div>
// //               </li>
// //               <li className="w-full border-b border-gray-200 sm:border-b-0 dark:border-gray-600">
// //                 <div className="flex items-center pl-6">
// //                   <input id="horizontal-list-radio-id" type="radio" value="" name="list-radio"
// //                          ref={minorUpdateRef}
// //                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-0 dark:bg-gray-600 dark:border-gray-500" />
// //                   <label htmlFor="horizontal-list-radio-id"
// //                          className="w-full py-3 ml-2 text-sm font-normal text-gray-700 dark:text-gray-300">Minor
// //                     Update</label>
// //                 </div>
// //               </li>
// //             </ul>
// //
// //
// //             <div className="text-base pb-2 font-semibold text-gray-700 pt-12">
// //               Briefly summarise your changes
// //             </div>
// //
// //             {/*todo add permission group settings like global and stuff next*/}
// //             <div className="w-full min-h-12 mb-6 rounded-lg text-xs flex">
// //               <textarea
// //                 ref={changeDescriptionRef}
// //                 className="bg-white rounded-lg w-full h-full resize-none py-3 px-4 border border-gray-200 focus:ring-0 focus:outline-none text-start items-baseline align-text-top overflow-scroll [&::-webkit-scrollbar]:hidden [-ms-overflow-style:'none'] [scrollbar-width:'none']"
// //                 placeholder="e.g. Added a new section on the importance of..." name="Text1"></textarea>
// //             </div>
// //
// //             {displayError && (
// //               <div className="text-sm font-normal mb-2 text-red-400">
// //                 Please fill out all fields
// //               </div>
// //             )}
// //
// //             <button
// //               className={`w-full bg-white shadow-sm font-semibold text-gray-700 border-gray-200 border rounded-lg h-12 mt-6 hover:bg-gray-50`}
// //               onClick={() => {
// //
// //                 const updateTypeFilled = (majorUpdateRef.current?.checked || minorUpdateRef.current?.checked) ?? false
// //                 const changeDescriptionFilled = changeDescriptionRef.current?.value !== null && changeDescriptionRef.current?.value !== ""
// //                 if (!updateTypeFilled || !changeDescriptionFilled) {
// //                   setDisplayError(true)
// //                   return
// //                 }
// //
// //                 let currentVersion = topicVersionState.version ?? "1.0"
// //                 const arr = currentVersion.split(".").map((x) => parseInt(x))
// //
// //                 if (majorUpdateRef.current?.checked) {
// //                   majorUpdateRef.current.checked = false
// //                   arr[0] += 1
// //                   arr[1] = 0
// //                 }
// //
// //                 if (minorUpdateRef.current?.checked) {
// //                   minorUpdateRef.current.checked = false
// //                   arr[1] += 1
// //                 }
// //
// //                 const newVersion = `${arr[0]}.${arr[1]}`
// //                 setTopicVersionState({ isHidden: true, version: newVersion, broadcast: true })
// //
// //                 console.log("updating version: ", changeDescriptionRef.current?.value)
// //
// //                 axiosInstance.post("/graph/update-node/version", {
// //                   nodeId: objectId,
// //                   version: newVersion,
// //                   changeDescription: changeDescriptionRef.current?.value
// //                 })
// //
// //                 if (changeDescriptionRef.current) {
// //                   changeDescriptionRef.current.value = ""
// //                 }
// //               }}
// //             >
// //               <div>
// //                 Update Version
// //               </div>
// //             </button>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   )
// // }
//
//
// export function ImageUploadBox (props: {}) {
//
//   const isHidden = useReduxState((state: RootState) => state.imageUploadBoxIsHidden)
//   const setIsHidden = useReduxAction(setImageUploadBoxIsHiddenAction)
//   const setUrlSubmitted = useReduxAction(setImageUploadBoxUrlSubmittedAction)
//   const [isHovered, setIsHovered] = useState(false)
//   const handleMouseEnter = () => {
//     console.log('enter')
//     setIsHovered(true)
//   }
//
//   const handleMouseLeave = () => {
//     console.log('leave')
//     setIsHovered(false)
//   }
//
//   async function isImageUrl (url: string): Promise<boolean> {
//     const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg']
//     const extension = url.split('.').pop()?.toLowerCase()
//
//     // Check if the URL has a valid image extension
//     if (extension && imageExtensions.includes(extension)) {
//       return true
//     }
//
//     // Send a HEAD request to get the Content-Type of the resource
//     try {
//       const response = await fetch(url, { method: 'HEAD' })
//       const contentType = response.headers.get('content-type')
//
//       // Check if the Content-Type indicates an image
//       // @ts-ignore
//       return contentType && contentType.startsWith('image/')
//     } catch (error) {
//       // Handle any error that occurred during the request
//       return false
//     }
//   }
//
//   const inputRef = React.useRef<HTMLInputElement>(null)
//
//   const imageUrl =
//     'https://images.unsplash.com/photo-1688071467184-aceaa6f598cc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=987&q=80'
//
//   const [uploadClicked, setUploadClicked] = useState(false)
//
//   return (
//     <div className={isHidden ? 'hidden' : ''}>
//       <div
//         id="popup-modal"
//         tabIndex={-1}
//         className="p-4 fixed flex items-center justify-center z-50 overflow-x-hidden overflow-y-auto md:inset-0 max-h-full bg-gray-300 bg-opacity-50 "
//       >
//         <div className="relative w-full max-w-md max-h-full">
//           <div className="inline-block relative w-[28rem] bg-white rounded-lg shadow dark:bg-gray-700 p-6">
//             <div className="flex justify-between items-center content-center pb-8">
//               <div className="text-2xl font-semibold text-gray-700">
//                 Upload Image
//               </div>
//               <button
//                 onClick={() => {
//                   setIsHidden(true)
//                 }}
//               >
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   height="24"
//                   viewBox="0 -960 960 960"
//                   width="24"
//                   fill={gray[700]}
//                 >
//                   <path
//                     d="m249-207-42-42 231-231-231-231 42-42 231 231 231-231 42 42-231 231 231 231-42 42-231-231-231 231Z"
//                     className="fill-gray-500"
//                   />
//                 </svg>
//               </button>
//             </div>
//
//             <div className="flex items-center justify-center w-full">
//               <label
//                 htmlFor="dropzone-file"
//                 className={`${
//                   isHovered ? 'text-blue-500' : 'text-gray-400'
//                 } flex flex-col items-center justify-center w-full h-36 border-2 border-gray-300 hover:border-blue-500 border-dashed rounded-lg cursor-pointer bg-white dark:hover:bg-gray-800 dark:bg-gray-700 hover:bg-blue-50 dark:border-gray-600 dark:hover:border-gray-500`}
//                 onMouseEnter={handleMouseEnter}
//                 onMouseLeave={handleMouseLeave}
//               >
//                 <div className="flex flex-col items-center justify-center pt-8 pb-8">
//                   <svg
//                     aria-hidden="true"
//                     className={`${
//                       isHovered ? 'text-blue-500' : 'text-gray-400'
//                     } w-10 h-10 mb-3`}
//                     fill="none"
//                     stroke={isHovered ? '#3b82f6' : gray[400]}
//                     viewBox="0 0 24 24"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth="2"
//                       d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
//                     ></path>
//                   </svg>
//                   <p className="mb-2 text-sm dark:text-gray-400">
//                     <span className="font-semibold">Click to upload</span> or
//                     drag and drop
//                   </p>
//                   <p className="text-xs dark:text-gray-400">
//                     SVG, PNG, JPG or GIF (MAX. 800x400px)
//                   </p>
//                 </div>
//                 <input id="dropzone-file" type="file" className="hidden" />
//               </label>
//             </div>
//             <div className="text-sm pt-10 pb-2 font-semibold text-gray-700">
//               Or upload from URL
//             </div>
//             <div
//               className="w-full h-11 mb-4 rounded-lg text-xs bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:bg-white flex content-center justify-between items-center">
//               <input
//                 type="text"
//                 className="bg-gray-100 rounded-lg w-full py-3 px-4 focus:outline-none"
//                 placeholder="Add file url"
//                 ref={inputRef}
//               />
//               <div className="py-2 pr-2">
//                 <button
//                   className="px-3 pt-2 pb-6 h-6 w-18 rounded-lg text-xs text-gray-700 font-medium bg-white border text-center border-gray-200 hover:bg-gray-50"
//                   onClick={async () => {
//                     const imageUrl = inputRef?.current?.value ?? ''
//                     console.log(imageUrl)
//                     if (imageUrl === '') {
//                       // @ts-ignore
//                       inputRef.current.value = ''
//                       return
//                     }
//
//                     try {
//                       const result = await isImageUrl(imageUrl)
//                       if (result) {
//                         console.log('Valid image URL')
//                         // @ts-ignore
//                         inputRef.current.value = ''
//                         setUrlSubmitted(imageUrl)
//                         setIsHidden(true)
//                       } else {
//                         console.log('Invalid image URL')
//                         // @ts-ignore
//                         inputRef.current.value = ''
//                       }
//                     } catch (e) {
//                       console.error('Error validating image URL:', e)
//                     }
//                   }}
//                 >
//                   Upload
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }
//
//
// // type DynamicFormProps = {
// //   onSubmit: (values: Record<string, any>) => void;
// //   strategy: ModalStrategy
// // };
//
// // const DynamicForm: React.FC<DynamicFormProps> = ({ onSubmit, strategy }) => {
// //   const [formValues, setFormValues] = useState(ModalOutputStateFactory.empty());
// //   const template = ModalStructureFactory.build(strategy)
// //
// //   const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
// //     const { name, value } = event.target;
// //     setFormValues((prev) => ({ ...prev, [name]: value }));
// //   };
// //
// //   const handleSubmit = (event: React.FormEvent) => {
// //     event.preventDefault();
// //     onSubmit(formValues); // Pass all form values to the submit handler
// //   };
// //
// //   return (
// //
// //   )
// // };
//
//
// function UrlCreationForm (props: { structure: ModalInputType }) {
//   const [modalInputState, setModalInputState] = useReduxPair((state: RootState) => state.modalInputState, setModalInputStateAction)
//   const setModalOutputState = useReduxAction(setModalOutputStateAction)
//
//   // const handleChange = useCallback((event: any, key: string) => {
//   //   setModalOutputState((prev: Record<any, any>) => ({
//   //     ...prev,
//   //     [key]: event.target.value,
//   //   }));
//   // }, [])
//
//   const [inputValue, setInputValue] = useState(modalInputState[props.structure] || '') // Temporary local input value
//   const [savedValue, setSavedValue] = useState('') // Saved value on blur
//
//   useEffect(() => {
//     logInfo('effect', modalInputState)
//     setInputValue(modalInputState[props.structure] || '')
//   }, [modalInputState, props.structure])
//
//
//   const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//     setInputValue(event.target.value)
//   }
//
//   // Save the input value on blur
//   const handleBlur = (event: any, key: ModalComponentType) => {
//     setModalInputState((prev: Record<any, any>) => ({
//       ...prev,
//       [key]: inputValue
//     }))
//     //   console.log("Saved Value:", inputValue); // Example of saved data
//   }
//
//   return <div>
//     <div className="text-sm pb-2 font-semibold text-gray-700">
//       Link
//     </div>
//     <div
//       className="w-full h-11 mb-4 rounded-lg text-xs focus:outline-none focus:ring-2 focus:ring-blue-500 focus:bg-white flex content-center justify-between items-center">
//       <input
//         type="text"
//         className="bg-white border border-gray-200 rounded-lg w-full py-3 px-4 focus:outline-none"
//         placeholder="Insert your link"
//         onChange={handleChange}
//         value={inputValue}
//         onBlur={(e) => {
//           handleBlur(e, ModalComponentType.label)
//         }}
//       />
//     </div>
//   </div>
// }
//
// function TitleCreationForm (props: { structure: ModalInputType }) {
//   const [modalInputState, setModalInputState] = useReduxPair((state: RootState) => state.modalInputState, setModalInputStateAction)
//   const handleChange = (event: any, key: string) => {
//     setModalInputState((prev: Record<any, any>) => {
//       prev[key] = event.target.value
//       return prev
//     })
//   }
//
//   return <div>
//     <div className="text-2xl pb-2 font-semibold text-gray-700">
//       Title
//     </div>
//     <div
//       className="w-full h-11 mb-4 rounded-lg text-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:bg-white flex content-center justify-between items-center">
//       <input
//         type="text"
//         className="bg-form-fill text-form-text rounded-lg w-full py-2 px-5 focus:outline-none"
//         placeholder="Insert your title"
//         onChange={(e) => {
//           handleChange(e, ModalComponentType.label)
//         }}
//       />
//     </div>
//   </div>
// }
//
// function StatCardCreationForm (props: {
//   structure: ModalInputType,
// }) {
//   const [modalInputState, setModalInputState] = useReduxPair((state: RootState) => state.modalInputState, setModalInputStateAction)
//   const handleChange = (event: any, key: string) => {
//     setModalInputState((prev: Record<any, any>) => {
//       prev[key] = event.target.value
//       return prev
//     })
//   }
//
//   return <div>
//     <TitleCreationForm structure={props.structure} />
//   </div>
// }
//
// function DonutWidgetCreationForm (props: {
//   structure: ModalInputType,
// }) {
//   const [rows, setRows] = useState([{ label: 'Untitled', value: 1, color: '#A3A3A3' }])
//   const [modalInputState, setModalInputState] = useReduxPair((state: RootState) => state.modalInputState, setModalInputStateAction)
//   const handleChange = (event: any, key: string) => {
//     setModalInputState((prev: Record<any, any>) => {
//       prev[key] = event.target.value
//       return prev
//     })
//   }
//
//
//   return <div>
//     <DonutChart data={rows}></DonutChart>
//     <div>
//       <div className="text-sm pb-2 font-semibold text-gray-700">
//         Data
//       </div>
//       {rows.map((label, index) => {
//         return <div
//           className="w-full h-11 mb-4 rounded-lg text-xs focus:outline-none focus:ring-2 focus:ring-blue-500 focus:bg-white flex content-center justify-between items-center">
//           <input
//             type="text"
//             className="bg-white border border-gray-200 rounded-lg w-full py-3 px-4 focus:outline-none"
//             placeholder="Insert your title"
//             onChange={(value) => {
//               const updatedLabel = value.target.value
//               setRows((rows) => rows.map((row, rowIndex) => {
//                   if (rowIndex === index) {
//                     return {
//                       ...row,
//                       value: 1,
//                       color: '#A3A3A3',
//                       label: updatedLabel
//                     }
//                   }
//                   return row
//                 })
//               )
//             }}
//           />
//           <div className="bg-white border border-gray-200 rounded-lg w-16 h-full ml-4">
//             <input
//               type="text"
//               className="bg-white border border-gray-200 rounded-lg w-full py-3 px-4 focus:outline-none"
//               placeholder="Value"
//               onChange={(value) => {
//                 const updatedValue = parseInt(value.target.value)
//                 setRows((rows) => rows.map((row, rowIndex) => {
//                     if (rowIndex === index) {
//                       return {
//                         ...row,
//                         value: Number.isNaN(updatedValue) ? 1 : updatedValue
//                       }
//                     }
//                     return row
//                   })
//                 )
//               }}
//             />
//           </div>
//         </div>
//       })}
//
//       <button
//         className="w-full h-11 mb-4 rounded-lg text-xs outline-none focus:bg-white flex content-center justify-between items-center"
//         onClick={() => {
//           setRows(rows => rows.concat({ label: '', value: 0, color: '#A3A3A3' }))
//         }}
//       >
//         <div className="bg-white border border-gray-200 rounded-lg w-full py-3 px-4 focus:outline-none">
//           <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
//             <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z" />
//           </svg>
//         </div>
//       </button>
//
//     </div>
//   </div>
// }
//
//
// const DonutChart = ({
//                       width = 300,
//                       height = 300,
//                       margin = { top: 40, left: 40, right: 40, bottom: 40 },
//                       data = [{ label: '', value: 1, color: '#A3A3A3' }]
//                     }) => {
//   const innerRadius = width / 4
//   const outerRadius = width / 2 - margin.top
//
//   return (
//     <div style={{ display: 'flex' }}>
//       {/* Donut Chart */}
//       <svg width={width} height={height}>
//         <Group top={height / 2} left={width / 2}>
//           <Pie
//             data={data}
//             pieValue={(d) => d.value}
//             outerRadius={outerRadius}
//             innerRadius={innerRadius}
//             cornerRadius={3}
//             padAngle={0.02}
//           >
//             {(pie) => pie.arcs.map((arc, index) => {
//               const [centroidX, centroidY] = pie.path.centroid(arc)
//               return (
//                 <g key={`arc-${arc.data.label}-${index}`}>
//                   <path d={pie.path(arc) ?? undefined} fill={arc.data.color} />
//                   <text
//                     x={centroidX}
//                     y={centroidY}
//                     dy=".33em"
//                     fill="white"
//                     fontSize={12}
//                     textAnchor="middle"
//                   >
//                     {arc.data.label}
//                   </text>
//                 </g>
//               )
//             })}
//           </Pie>
//         </Group>
//       </svg>
//
//       {/* Legend */}
//       <div style={{ marginLeft: '20px' }}>
//         <h3>Legend</h3>
//         <ul>
//           {data.map((entry, index) => (
//             <li key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
//               <div
//                 style={{
//                   width: '20px',
//                   height: '20px',
//                   backgroundColor: entry.color,
//                   marginRight: '10px'
//                 }}
//               ></div>
//               <span>{entry.label}</span>
//             </li>
//           ))}
//         </ul>
//       </div>
//     </div>
//   )
// }
//
//
// // class ResultValidation {
// //   type: string
// //   constructor(type: "string" | "id") {
// //     this.type = type
// //   }
// //
// //   validate() {
// //
// //   }
// // }
//
//
// function WorkspaceCreateTile (props: { setCreateWorkspaceBoxIsHidden: Dispatch<SetStateAction<boolean>> }) {
//
//   const [isSelected, setIsSelected] = useState(false)
//   const containerRef = React.useRef<HTMLButtonElement>(null)
//
//
//   return <button ref={containerRef}
//                  className={`w-full mb-2 border-2 border-dashed rounded-xl bg-transparent flex justify-center items-center ${isSelected ? 'border-blue-500' : 'border-gray-200'}`}
//                  onClick={() => {
//                    props.setCreateWorkspaceBoxIsHidden(false)
//                  }}
//                  onMouseEnter={() => {
//                    setIsSelected(true)
//                  }}
//                  onMouseLeave={() => {
//                    setIsSelected(false)
//                  }}
//   >
//     <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48"
//          fill={isSelected ? '#3b82f6' : gray[200]}>
//       <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z" />
//     </svg>
//     {/*<div className="h-[80%] w-full rounded-t-xl bg-gray-100 aspect-video border-b border-b-gray-200">*/}
//
//     {/*</div>*/}
//     {/*<div className="p-3 font-medium">*/}
//     {/*  {props.title}*/}
//     {/*</div>*/}
//   </button>
// }
//
// function ProtectedPage ({
//                           widget,
//                           path
//                         }: {
//   widget: JSX.Element;
//   path: string;
// }) {
//   const location = useLocation()
//   const [isLoggedIn, setIsLoggedIn] = useState<boolean | null>(null)
//
//   const navigate = useNavigate()
//   // res.redirect(`${frontendUrl}/home`)
//   useEffect(() => {
//     // This function will be called whenever the URL changes
//     // logInfo("URL changed:", location.pathname);
//     // logInfo("location", location);
//
//     if (!location.pathname.startsWith(path)) {
//       return
//     }
//
//     axiosInstance
//       .post(absoluteEndpoint('/user/validate-refresh-token'), { params: {} })
//       .then((response) => {
//         if (response.status === 200) {
//           const isLoggedIn = true
//           setIsLoggedIn(isLoggedIn)
//         }
//       }).catch(err => {
//       logInfo(err)
//       navigate('/login')
//     })
//   }, [location])
//
//   useEffect(() => {
//     if (!location.pathname.startsWith(path)) {
//       return
//     }
//
//     if (isLoggedIn === false) {
//       navigate('/login')
//     }
//   }, [navigate, isLoggedIn, location, path])
//
//   if (isLoggedIn === null) {
//     return LoadingScreen()
//   }
//
//   if (isLoggedIn) {
//     return (
//       <div>
//         {/*<script*/}
//         {/*  async*/}
//         {/*  // src={`https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}&loading=async&libraries=places&callback=initMap`}*/}
//         {/*  src={`https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}&loading=async&libraries=places`}*/}
//         {/*></script>*/}
//         <GoogleMapScripts></GoogleMapScripts>
//         {/*<script*/}
//         {/*  src={*/}
//         {/*    `https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}&libraries=places`*/}
//         {/*  }*/}
//         {/*></script>*/}
//
//         {widget}
//       </div>
//     )
//   } else {
//     return <div></div>
//   }
// }
//
// export enum SelectedTab {
//   Workspaces = 'Workspaces',
//   Api = 'Api',
//   ApplicationRegistry = 'ApplicationRegistry',
// }
//
// function LoadingScreen () {
//   return (
//     <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-white z-50">
//       <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-gray-900"></div>
//     </div>
//   )
// }
//
// // need schema to know word
// // function getOptions
//
// export const Api = (props: {}) => {
//   return <div
//     className="bg-accent-3 w-[calc(100%-15rem)] relative left-60 min-h-screen mr-60 overflow-x-clip 2xl:px-96 xl:px-48 md:px-16 sm:px-8 text-accent-dark-1 pb-16 pt-16">
//     <MarkdownArticle markdownContent={apiArticle1}></MarkdownArticle>
//     <ApiCodeBlock></ApiCodeBlock>
//     <MarkdownArticle markdownContent={apiArticle2}></MarkdownArticle>
//
//   </div>
// }
//
// export enum FilterStatus {
//   PRESENT = 'Has ',
//   NOT_PRESENT = 'Has no',
//   UNDEFINED = ''
// }
//
// export const WorkspaceRule = (props: {
//   entity: string, rules: Resource[]
// }) => {
//   const [showList, setShowList] = useState(false)
//
//   return <div>
//     <div
//       className={`relative p-4 rounded-lg bg-accent-5 w-96 ${showList ? 'h-72' : 'h-24'} mt-8 mb-8 flex flex-col justify-between`}>
//       {showList && <div className="pointer-events-none absolute bottom-0 right-0 w-full h-16
//               bg-gradient-to-t from-accent-5 to-transparent rounded-lg">
//       </div>}
//
//       <div className="text-2xl font-semibold pb-1 flex justify-between items-center">
//
//         {props.entity} Rules
//         <button className="" onClick={() => setShowList(state => !state)}>
//           {React.cloneElement(showList ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />, { size: '1.5rem' })}
//         </button>
//
//       </div>
//       <div className="text-accent-1 font-semibold">
//         {props.rules.length} active rules
//       </div>
//
//       <div className="mb-3"></div>
//
//       <div className="overflow-scroll pb-4 font-medium text-sm">
//
//         {showList && <div>
//           {props.rules.map(rule => {
//             return <li className=" pl-1.5">
//               Must have {rule}
//             </li>
//           })}
//         </div>
//         }
//       </div>
//
//       {/*<div className="text-accent-1 font-semibold text-xxs">*/}
//       {/*  Sponsored by {props.sponsor}*/}
//       {/*</div>*/}
//
//
//     </div>
//   </div>
// }
//
// export const ApplicationRegistry = (props: {}) => {
//   const [items, setItems] = useState(() => (DEFAULT_ICONS).map(normalize))
//   const [options, setOptions] = useState({
//     data: Object.keys(Resource).map(key => key as Resource),
//     isVisible: false,
//     x: 0,
//     y: 0
//   })
//   const [filters, setFilters] = useState<{ exists: FilterStatus, resource: Resource }[]>([])
//   const [filterSet, setFilterSet] = useState(new Set<Resource>([]))
//   // [
//   //   { exists: FilterStatus.PRESENT, resource: Resource.Architecture },
//   //   { exists: FilterStatus.NOT_PRESENT, resource: Resource.Architecture }
//   // ]
//
//   const style = 'font-medium text-sm text-accent-5 bg-accent-1'
//
//   const itemsProcessed = items.map(item => item.label)
//
//   // const add = () => {
//   //   setFilters(filters.map((elem, idx) => {
//   //     // if (idx === index) {
//   //     // return { data: elem.data.concat('test'), isComplete: elem.isComplete }
//   //     // }
//   //
//   //     return elem
//   //   }))
//   //   setFilterSet(filterSet => filterSet.add())
//   // }
//
//   return <div
//     className="bg-accent-3 w-[calc(100%-15rem)] relative left-60 min-h-screen mr-60 overflow-x-clip 2xl:px-96 xl:px-48 md:px-16 sm:px-8 text-accent-dark-1 pb-16 pt-16">
//     {/*<MarkdownArticle markdownContent={apiArticle1}></MarkdownArticle>*/}
//     {/*<ApiCodeBlock></ApiCodeBlock>*/}
//     {/*<MarkdownArticle markdownContent={apiArticle2}></MarkdownArticle>*/}
//
//     <input className={`${InputLabelStyle}`}>
//
//     </input>
//     {/*<div className="flex pb-4">*/}
//     {/*  <div className="flex rounded-lg bg-accent-2 h-12 w-full text-left items-center align-middle p-2">*/}
//     {/*    Architecture exists*/}
//     {/*  </div>*/}
//     {/*</div>*/}
//
//     <div className={WelcomeHeader}>
//
//       Rules
//     </div>
//     <div className="grid grid-cols-2">
//       <WorkspaceRule entity={'Service'}
//                      rules={[Resource.Architecture, Resource.Code, Resource.Code, Resource.Code, Resource.Code, Resource.Code, Resource.Code, Resource.Code, Resource.Code, Resource.Code, Resource.Code]} />
//       <WorkspaceRule entity={'Project'}
//                      rules={[Resource.Architecture, Resource.Code, Resource.Code, Resource.Code, Resource.Code, Resource.Code, Resource.Code, Resource.Code, Resource.Code, Resource.Code, Resource.Code]} />
//     </div>
//
//     <div>
//
//       Filters
//     </div>
//     {/*<div className="bg-accent-3 border-accent-6 font-medium border border-dashed text-accent-8 text-sm rounded-full p-2 w-fit flex justify-center space-2 items-center">*/}
//     {/*  {<MdAdd/>}*/}
//     {/*  Missing Label*/}
//     {/*</div>*/}
//
//     <button className="px-2 border rounded-full relative" onClick={(click: any) => {
//       setOptions((option) => {
//         return {
//           data: Object.keys(Resource).map(key => key as Resource),
//           isVisible: true,
//           x: click.clientX,
//           y: click.clientY
//         }
//       })
//     }}>Add Filter
//       {
//         (options.isVisible || false)
//         && <div className="absolute left-0 top-10 z-50 w-40 h-fit bg-accent-5 rounded-lg flex flex-col py-2" style={{}}>
//           {options.data.map(data => <button onClick={() => {
//             setFilters(filters => filters.concat({ resource: data, exists: FilterStatus.PRESENT }))
//             setFilterSet(filters => filters.add(data))
//             setOptions(options => {
//               return { ...options, isVisible: false, data: options.data.filter(r => !filterSet.has(r)) }
//             })
//           }}>
//             {data}
//           </button>)}
//         </div>
//       }
//     </button>
//
//
//     <div className="w-fit pb-4 flex flex-wrap py-4">
//
//       {filters.map(filter => <div className="p-2 border-accent-5">
//         {filter.resource}
//       </div>)}
//
//       {/*{filters.map((filter, index) => {*/}
//       {/*  return <FilterViewer add={add} remove={() => {*/}
//       {/*    setFilters(filters.filter((elem, idx) => {*/}
//       {/*      return idx !== index*/}
//       {/*    }))*/}
//       {/*  }} resource={filter.resource} exists={filter.exists}></FilterViewer>*/}
//       {/*})}*/}
//       {/*{*/}
//       {/*  <button onClick={add}*/}
//       {/*          className={`px-3 py-1 rounded-r-full ${'rounded-l-full'} ${style}`}>*/}
//       {/*    ...*/}
//       {/*  </button>}*/}
//     </div>
//
//
//     {/*</div>}*/}
//
//
//     {/*<div className="bg-accent-3 w-96">*/}
//     {/*  <A></A>*/}
//     {/*</div>*/}
//
//
//     <div className="relative overflow-x-auto border sm:rounded-lg">
//       <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
//         <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
//         <tr>
//           <th scope="col" className="px-6 py-3">
//
//           </th>
//           <th scope="col" className="px-6 py-3">
//             Product name
//           </th>
//           <th scope="col" className="px-6 py-3">
//             Resources
//           </th>
//         </tr>
//         </thead>
//         <tbody>
//
//         <ApplicationRow serviceName="Starscream" data={itemsProcessed} rules={[Resource.Architecture]}></ApplicationRow>
//         <ApplicationRow serviceName="Grimlock" data={itemsProcessed} rules={[Resource.Architecture]}></ApplicationRow>
//         <ApplicationRow serviceName="Arcee" data={itemsProcessed} rules={[Resource.Architecture]}></ApplicationRow>
//         </tbody>
//       </table>
//     </div>
//
//   </div>
// }
//
// const FilterViewer = (props: { resource: Resource, exists: FilterStatus, add: () => any, remove: () => any }) => {
//
//   const style = 'font-medium text-sm text-accent-5 bg-accent-1'
//
//   // if (props.source === "") {
//   //   return wrapper(<div>
//   //     <div className="py-1 bg-accent-5">
//   //       {"Action"}
//   //     </div>
//   //   </div>)
//   // }
//
//   // bg-accent-1 text-accent-5
//   // rounded-full border
//   return <div className="flex font-medium text-sm border rounded-full mr-2 mb-2">
//     {/*<div className="py-1 rounded-l-full px-2 border-r border-dashed border-gray-300 mr-2" >*/}
//     {/**/}
//     {/*TEST*/}
//     {/*</div>*/}
//     {
//       <button onClick={() => {
//         props.remove()
//       }} className={`flex items-center h-full px-3 py-1 rounded-l-full border-r border-dashed ${style}`}>
//         <MdClose></MdClose>
//       </button>}
//
//     <div className={`py-1 border-r border-dashed px-3   ${style}`}>
//       {props.exists}
//     </div>
//     <div className={`py-1 border-r border-dashed px-3 ${'rounded-r-full border-none'} ${style}`}>
//       {props.resource}
//     </div>
//
//
//     {/*{props.exists === FilterStatus.UNDEFINED &&*/}
//     {/*  <button onClick={() => props.add()}*/}
//     {/*          className={`px-3 py-1 rounded-r-full ${props.resource == null && 'rounded-l-full'} ${style}`}>*/}
//     {/*    ...*/}
//     {/*  </button>}*/}
//
//     {/*{*/}
//     {/*  <button onClick={() => props.add()}*/}
//     {/*          className={`px-3 py-1 rounded-r-full ${props.resource == null && 'rounded-l-full'} ${style}`}>*/}
//     {/*    ...*/}
//     {/*  </button>}*/}
//
//
//   </div>
// }
//
//
// const ApplicationRow = (props: { serviceName: string, data: any[], rules: Resource[] }) => {
//   const [isExpanded, setIsExpanded] = useState(false)
//   const set = new Set(props.data)
//
//   logInfo(props.rules, set)
//   for (const rule of props.rules) {
//     if (!set.has(rule)) {
//       return <div></div>
//     }
//   }
//
//   return <tr
//     className="bg-white w-full border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200 hover:bg-gray-50 dark:hover:bg-gray-600">
//
//     <td className="align-top w-20 px-6 py-4 text-right items-start">
//       <button onClick={() => {
//         setIsExpanded(wasOpen => {
//           return !wasOpen
//         })
//       }}
//               className="h-full font-medium text-blue-600 dark:text-blue-500 hover:underline">{!isExpanded ? 'Show' : 'Hide'}</button>
//     </td>
//     <th scope="row" className="align-top px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
//       {props.serviceName}
//     </th>
//     {/*<th scope="row" className="flex px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">*/}
//     {/*  {props.serviceName}*/}
//     {/*</th>*/}
//     <ApplicationResources canAdd={isExpanded} cols={4} preview={!isExpanded}
//                           initialItems={props.data}></ApplicationResources>
//
//     {/*<td className={`px-2 flex overflow-scroll w-96 `}>*/}
//     {/*  {props.data.map((item: any) => (*/}
//     {/*    <Tile label={item.label} id={item.id} dragging={false} />*/}
//     {/*  ))}*/}
//     {/*</td>*/}
//
//   </tr>
// }
//
//
// const ApiCodeBlock = (props: {}) => {
//   const [codeBlock, setCodeBlock] = useState([{
//     title: '~/.zshrc',
//     content: `export BLUESCROLLS_API_TOKEN="your-api-token"`
//   }])
//
//   return <div className="relative">
//     <button className="absolute top-6 right-2 bg-accent-1 py-1.5 px-3 rounded-lg text-sm font-semibold text-accent-3"
//             onClick={() => {
//               getUserAccessToken().then((newToken: string) => {
//                 setCodeBlock(
//                   [{
//                     title: '~/.zshrc',
//                     content: `export BLUESCROLLS_API_TOKEN="${newToken}"`
//                   }]
//                 )
//               })
//             }}>
//       Generate token
//     </button>
//     <CodeBlock blocks={codeBlock}></CodeBlock>
//   </div>
// }
//
//
// const MarkdownArticle = (props: { markdownContent: string, className?: string }) => {
//   const editor = withReact(createEditor())
//
//   const initialValue = markdownToSlate(props.markdownContent)
//
//   const renderElement = useCallback(
//     // @ts-ignore
//     (props) => <Element {...props} />,
//     []
//   )
//
//   // @ts-ignore
//   const renderLeaf = useCallback((props) => <Leaf {...props} />, [])
//
//   return (
//     <div className={props.className || ''}>
//       <Slate editor={editor} initialValue={initialValue} value={initialValue}
//              onChange={(newValue: any) => console.log(newValue)}>
//         <Editable renderLeaf={renderLeaf} renderElement={renderElement} readOnly />
//       </Slate>
//     </div>
//   )
// }
//
// interface CodeBlockTab {
//   title: string,
//   content: string
// }
//
// export const CodeBlock = (props: { blocks: CodeBlockTab[] }) => {
//   const [buttonText, setButtonText] = useState('Copy Code')
//   const contentRef = useRef<HTMLDivElement>(null) // Reference to the content you want to copy
//
//   const handleCopyToClipboard = async () => {
//     // Get the text content from the div
//     const textToCopy = contentRef.current?.innerText || ''
//
//     try {
//       await navigator.clipboard.writeText(textToCopy)
//       setButtonText('Copied!')
//
//       // Reset button text back to 'Copy Code' after 2 seconds
//       setTimeout(() => {
//         setButtonText('Copy Code')
//       }, 2000)
//     } catch (err) {
//       console.error('Failed to copy: ', err)
//     }
//   }
//
//   const [selectedTab, setSelectedTab] = useState(props.blocks[0])
//   useEffect(() => {
//     setSelectedTab(props.blocks[0])
//   }, [props.blocks])
//
//   return (
//     <div className="w-full h-fit py-4">
//       <div className="rounded-t-lg bg-accent-3 border border-accent-5">
//         <div className="flex space-x-8 px-6 items-center">
//           {props.blocks.map((block, index) => {
//             return <button
//               className={`w-fit h-12 font-medium ${selectedTab.title === block.title ? 'text-accent-1 underline underline-offset-16' : 'text-standard-text'}`}
//               onClick={() => {
//                 setSelectedTab(block)
//               }}
//             >
//               {block.title}
//             </button>
//           })}
//         </div>
//
//       </div>
//       <div className="relative w-full rounded-b-lg bg-accent-5 ">
//         <div ref={contentRef} className="p-4 text-standard-text font-mono px-7 overflow-scroll">
//           {/* Replace this content with whatever you want to copy */}
//           {selectedTab.content}
//         </div>
//         <button
//           onClick={handleCopyToClipboard}
//           className="flex w-28 justify-center items-center absolute top-2 right-2 space-x-1.5 hover:bg-accent-5 py-2 px-2 rounded-lg"
//         >
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             height="20"
//             viewBox="0 -960 960 960"
//             width="20"
//             fill="currentColor"
//           >
//             {IconPath.copy}
//           </svg>
//           <div className="text-xs font-semibold text-standard-text">
//             {buttonText}
//           </div>
//         </button>
//
//       </div>
//     </div>
//   )
// }
//
//
// export interface UserProfile {
//   picture?: string;  // Optional property
//   firstName?: string;  // Optional property
//   lastName?: string;  // Optional property
// }
//
//
// export const Logo = (props: { className: string }) => {
//   return <div className={`bg-gradient-logo font-extrabold text-4xl ${props.className}}`}>
//     O
//   </div>
// }
//
//
// const GraphLoadingView = (props: { graphHasLoaded: boolean }) => {
//   return <div role="status"
//               className={`flex h-screen w-full items-center content-center justify-center place-items-center transform transition-all duration-700 ${!props.graphHasLoaded ? 'opacity-100' : 'opacity-0'} [&::-webkit-scrollbar]:hidden [-ms-overflow-style:'none'] [scrollbar-width:'none']`}>
//     <svg aria-hidden="true" className="inline w-10 h-10 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
//          viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
//       <path
//         d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
//         fill={gray[200]} />
//       <path
//         d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
//         fill={blue[700]} />
//     </svg>
//     <span className="sr-only">Loading...</span>
//   </div>
// }
//
// // const GraphSuggestionList = () => {
// //   return (
// //     <div className="fixed bottom-4 left-4 rounded-lg w-60 z-10">
// //       <GraphSuggestion suggestion={'Suggestion 1'}></GraphSuggestion>
// //       <SuggestionCard></SuggestionCard>
// //     </div>
// //   )
// // }
//
//
// // const GraphSuggestion = (props: { suggestion: string }) => {
// //   return <div className="">{/*{props.suggestion}*/}</div>
// // }
//
// // const SuggestionCard = () => {
// //   const [hidden, setHidden] = React.useState(true)
// //
// //   return (
// //     <div
// //       className="w-full max-w-sm p-4 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
// //       <div className="flex flex-row items-center text-center">
// //         <button
// //           type="button"
// //           className="flex items-center justify-between w-full font-medium text-left text-gray-500 border-gray-200 dark:border-gray-700 dark:text-gray-400"
// //           onClick={() => {
// //             setHidden(!hidden)
// //           }}
// //         >
// //           <div className="w-6 h-6 shrink-0 -ml-1">
// //             <svg
// //               className={`${!hidden ? 'rotate-180' : 'rotate-0'}`}
// //               fill="currentColor"
// //               viewBox="0 0 20 20"
// //               xmlns="http://www.w3.org/2000/svg"
// //             >
// //               <path
// //                 fillRule="evenodd"
// //                 d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
// //                 clipRule="evenodd"
// //               ></path>
// //             </svg>
// //           </div>
// //           <div className="font-semibold text-gray-900 md:text-lg dark:text-white unselectable">
// //             Suggestions
// //           </div>
// //           <span
// //             className="inline-flex items-center unselectable justify-center px-2 py-0.5 ml-3 text-xs font-medium text-blue-800 bg-blue-200 rounded dark:bg-gray-700 dark:text-gray-400">
// //             3 Found
// //           </span>
// //         </button>
// //       </div>
// //       {/*<p className="text-sm font-normal text-gray-500 dark:text-gray-400">Connect with one of our available wallet*/}
// //       {/*    providers or create a new one.</p>*/}
// //       <div className={hidden ? 'hidden' : 'visible'}>
// //         <ul className="mt-4 mb-2 space-y-3">
// //           <li>
// //             <Link
// //               className="flex items-center p-2 text-base font-bold text-gray-900 rounded-lg bg-gray-50 hover:bg-gray-100 group hover:shadow dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-white">
// //               <div className="text-lg pl-1"> 🧹</div>
// //               <span className="flex-1 ml-3 whitespace-nowrap">
// //                 {' '}
// //                 Outdated Files{' '}
// //               </span>
// //               <div
// //                 className="inline-flex items-center justify-center w-4 h-4 ml-2 text-xs font-semibold text-blue-800 bg-blue-200 rounded-full">
// //                 2
// //               </div>
// //
// //               {/*<span className="inline-flex items-center justify-center px-2 py-0.5 ml-3 text-xs font-medium text-gray-500 bg-gray-200 rounded dark:bg-gray-700 dark:text-gray-400">Popular</span>*/}
// //             </Link>
// //           </li>
// //           <li>
// //             <Link
// //               className="flex items-center p-2 text-base font-bold text-gray-900 rounded-lg bg-gray-50 hover:bg-gray-100 group hover:shadow dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-white">
// //               <div className="text-lg pl-1"> 🔧</div>
// //               <span className="flex-1 ml-3 whitespace-nowrap">
// //                 {' '}
// //                 Topics To Fix{' '}
// //               </span>
// //             </Link>
// //           </li>
// //           <li>
// //             <Link
// //               className="flex items-center p-2 text-base font-bold text-gray-900 rounded-lg bg-gray-50 hover:bg-gray-100 group hover:shadow dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-white">
// //               <div className="text-lg pl-1"> 🗑️</div>
// //               <span className="flex-1 ml-3 whitespace-nowrap">
// //                 {' '}
// //                 Clutter Found{' '}
// //               </span>
// //               <div
// //                 className="inline-flex items-center justify-center w-4 h-4 ml-2 text-xs font-semibold text-blue-800 bg-blue-200 rounded-full">
// //                 1
// //               </div>
// //             </Link>
// //           </li>
// //         </ul>
// //         <div>
// //           <Link
// //             className="inline-flex items-center text-xs font-normal text-gray-500 hover:underline dark:text-gray-400">
// //             <svg
// //               className="w-3 h-3 mr-2"
// //               aria-hidden="true"
// //               focusable="false"
// //               data-prefix="far"
// //               data-icon="question-circle"
// //               role="img"
// //               xmlns="http://www.w3.org/2000/svg"
// //               viewBox="0 0 512 512"
// //             >
// //               <path
// //                 fill="currentColor"
// //                 d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm107.244-255.2c0 67.052-72.421 68.084-72.421 92.863V300c0 6.627-5.373 12-12 12h-45.647c-6.627 0-12-5.373-12-12v-8.659c0-35.745 27.1-50.034 47.579-61.516 17.561-9.845 28.324-16.541 28.324-29.579 0-17.246-21.999-28.693-39.784-28.693-23.189 0-33.894 10.977-48.942 29.969-4.057 5.12-11.46 6.071-16.666 2.124l-27.824-21.098c-5.107-3.872-6.251-11.066-2.644-16.363C184.846 131.491 214.94 112 261.794 112c49.071 0 101.45 38.304 101.45 88.8zM298 368c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42z"
// //               ></path>
// //             </svg>
// //             What does this mean?
// //           </Link>
// //         </div>
// //       </div>
// //     </div>
// //   )
// // }
//
// //const ContentEditable = () => {
// //   const [caretCoordinates, setCaretCoordinates] = useState({ top: 0, left: 0 });
// //   const contentEditableRef = useRef<HTMLDivElement>(null);
// //
// //   let y = 0;
// //   let x = 0;
// //   useEffect(() => {
// //     const getSelectionCoordinates = () => {
// //       const selection = window.getSelection();
// //       if (selection && selection.rangeCount > 0) {
// //         const range = selection.getRangeAt(0);
// //         const { left, top, height } = range.getBoundingClientRect();
// //         x = left;
// //         y = top + height;
// //       }
// //     };
// //
// //     const getSelectionCoordinatesAndUpdate = () => {
// //       getSelectionCoordinates();
// //       setCaretCoordinates({ left: x, top: y });
// //     };
// //
// //     contentEditableRef.current?.addEventListener(
// //       "mouseup",
// //       getSelectionCoordinatesAndUpdate
// //     );
// //     contentEditableRef.current?.addEventListener(
// //       "keyup",
// //       getSelectionCoordinates
// //     );
// //
// //     return () => {
// //       contentEditableRef.current?.removeEventListener(
// //         "mouseup",
// //         getSelectionCoordinates
// //       );
// //       // @ts-ignore
// //       contentEditableRef.current?.removeEventListener(
// //         "keyup",
// //         getSelectionCoordinates
// //       );
// //     };
// //   }, []);
// //
// //   return (
// //     <div ref={contentEditableRef} contentEditable className="text-center">
// //       Edit me
// //       {caretCoordinates && (
// //         <div
// //           className="bg-blue-300"
// //           style={{
// //             position: "absolute",
// //             left: caretCoordinates.left,
// //             top: caretCoordinates.top,
// //           }}
// //         >
// //           Caret is here!
// //         </div>
// //       )}
// //     </div>
// //   );
// // };
